import isEmpty from "lodash/isEmpty";
import { type GenericFiltersMap } from "utils/filterUtils";
import { MultiSelect, type MultiSelectItem } from "./MultiSelect";
import { type DropdownItemProps } from "semantic-ui-react";

interface FilterBaseProps<T extends string> {
  filter: GenericFiltersMap<T>;
  updateFilter: (filter: GenericFiltersMap<T>) => void;
  propertyName: T;
  className?: string;
  placeholder?: string;
  id?: string;
  search?: (list: DropdownItemProps[], searchString: string) => DropdownItemProps[];
}

export interface FilterMultiSelectProps<T extends string> extends FilterBaseProps<T> {
  items: MultiSelectItem[] | null;
  [key: string]: unknown;
}

function FilterMultiSelect<T extends string>(props: FilterMultiSelectProps<T>) {
  const { filter, updateFilter, propertyName, ...multiSelectProps } = props;

  const handleFilterChange = ({ value }: { value: (string | number)[] }) => {
    const newFilter = { ...filter };

    if (value.length !== 0) {
      newFilter[propertyName] = value;
    } else {
      delete newFilter[propertyName];
    }

    updateFilter(newFilter);
  };

  const selected = isEmpty(filter[propertyName]) ? [] : (filter[propertyName] as (string | number)[]);

  return <MultiSelect onMultiSelectChange={handleFilterChange} selected={selected} {...multiSelectProps} />;
}

export default FilterMultiSelect;
